export { default } from './selfie-photo';
